import type { RenderComponent } from 'hb-builder/types';
import { BUILDER_DOCUMENT_CHILDREN_TYPE } from 'hb-react/backoffice/types/builder/builderDocument';

const DroppableLastBlock: RenderComponent = () => <div />; // never used

const Render = () => null;

DroppableLastBlock.componentName =
  BUILDER_DOCUMENT_CHILDREN_TYPE.DROPPABLE_LAST_BLOCK;
DroppableLastBlock.Render = Render;

export default DroppableLastBlock;
